export enum ImageViewerReadType {
  Page = 'page',
  Scroll = 'scroll',
}
